module.exports = __webpack_public_path__ + "static/img/technologyu04.3af73199.svg";